import React, { Component } from 'react'
import propTypes from 'prop-types'
import { prefix } from 'helpers/component'

require('./progressBar.scss')

const getClassName = prefix('progressBar-')

class ProgressBar extends Component {
  render () {
    const { value, label, width, animate } = this.props

    let fillStyle = { width: value + '%' }
    if (animate) fillStyle = { ...fillStyle, transitionDuration: '500ms' }

    return (
      <div className={getClassName('container')} style={{ width }}>
        <div className={getClassName('label')}>{label}</div>
        <div className={getClassName('fill')} style={fillStyle}>
          <div className={getClassName('label')}>{label}</div>
        </div>
      </div>
    )
  }
}

ProgressBar.propTypes = {
  value: propTypes.number.isRequired,
  label: propTypes.oneOfType([
    propTypes.string,
    propTypes.element,
  ]),
  width: propTypes.oneOfType([
    propTypes.string,
    propTypes.number,
  ]),
  animate: propTypes.bool,
}

ProgressBar.defaultProps = {
  animate: true,
}

export default ProgressBar
